import React from 'react';
import './FactionLeprechaunsDescription.css';
import {
  LEPRECHAUNS_ADDITIONAL_BASIC_INCOME,
  LEPRECHAUNS_UNIT_SIZE_FOR_1_COIN_THEFT
} from "../../../../configs/factions/leprechauns";
import {CoinsStat} from "../../../PlayerStat/stats/CoinsStat";
import DescriptionValueWithIcon from "../../../PolicyCardOverlay/DescriptionValueWithIcon/DescriptionValueWithIcon";

const FactionLeprechaunsDescription = () => {
  const boot = <img
    className="faction-description-icon faction-description-icon-margin-right-left"
    src="/img/icons/speed.png"
    alt="Перемещение"
    title="Перемещение"
  />;

  const income = <CoinsStat
    text={`+${LEPRECHAUNS_ADDITIONAL_BASIC_INCOME}`}
    noShrinkOnMobile={true}
    isDarkColor={true}
    className={'policy-description-icon-margin-left'}
  />;

  const unit = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд'}
    title={'Отряд'}
  />;

  const theft = <CoinsStat
    text={1}
    noShrinkOnMobile={true}
    isDarkColor={true}
    className={'policy-description-icon-margin-right-left margin-right-important'}
  />;

  const size = <img
    className="faction-description-icon" src="/img/icons/unit size.png" alt="Размер отряда" title="Размер отряда"
  />;

  const theftSizeValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-right-left'}
    value={LEPRECHAUNS_UNIT_SIZE_FOR_1_COIN_THEFT}
    icon={size}
  />

  return (
    <>
      <div className="policy-description_line">
        <span className={'text-coins'}>
          Базовый доход
        </span>
        <span style={{color: '#f2bb42'}}></span>{income}.
      </div>
      <div className="policy-description_line policy-description_line-margin-top">
        В
        <span className={'text-war policy-description-icon-margin-left'}>
          фазе Войны
        </span>
        {unit} может вместо {boot}
      </div>
      <div className="policy-description_line">
        украсть у противника
      </div>
      <div className="policy-description_line">
        по {theft} за каждые свои {theftSizeValueAndIcon}.
      </div>
    </>
  );
};

export default FactionLeprechaunsDescription;
